// `onClick` should be added to every option from the component that uses this constant
export const IMPACT_ANALYSIS_OPTIONS = {
  PRE_CHANGE: {
    value: 'PRE-CHANGE',
    title: 'Pre change',
  },
  POST_CHANGE: {
    value: 'POST-CHANGE',
    title: 'Post change',
  },
};

export const IMPACTS_NOTIFICATIONS = {
  POST_CHANGE_NOT_POSSIBLE_FOR_DRAFT: 'A post-change analysis is only possible for completed versions not a draft.',
  POST_CHANGE_NO_EDIT_PERMISSIONS: 'You need edit permissions for this item to start the analysis.',
};
